/* eslint-disable react/jsx-props-no-spreading */
import classnames from 'classnames'
import { ButtonHTMLAttributes } from 'react'

import styles from './Button.module.scss'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  Icon?: React.ReactNode
  rounded?: boolean
  variant?: 'primary' | 'secondary'
}

const Button = ({ children, Icon = null, rounded = false, variant = 'primary', className, ...props }: ButtonProps) => {
  return (
    <button
      className={classnames(styles.button, { [styles.rounded]: rounded, [styles[variant]]: variant }, className)}
      {...props}
    >
      {children}
      {Icon && <div className={styles['icon-container']}>{Icon}</div>}
    </button>
  )
}

export default Button
